export default "__VITE_ASSET__CdC33V5H__"